import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, changeLanguage } from '../i18n';

interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang: string) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  // Get current language code
  const currentLanguageCode = i18n.language?.split('-')[0] || 'en';

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        className="rounded-md px-2 py-1.5 text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-sm font-medium">{currentLanguageCode.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 dark:bg-gray-800 dark:ring-gray-700">
          <div className="overflow-hidden py-1">
            {Object.entries(LANGUAGES).map(([code, { nativeName }]) => (
              <button
                key={code}
                onClick={() => handleLanguageChange(code)}
                className={`block w-full px-4 py-2 text-left text-sm ${
                  i18n.language === code
                    ? 'bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white'
                    : 'text-gray-700 dark:text-gray-300'
                } hover:bg-gray-100 dark:hover:bg-gray-700`}
              >
                {nativeName}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
